export default "__VITE_ASSET__Bhp4aAEk__"